import { connect } from 'react-redux';
import clone from 'lodash/cloneDeep';
import View from './PensionAddEditView';
import { currentClientId, data as dataSelector } from '../../AdvWorkflow/AdvWorkflowSelector';
import { graphPensionsSelector } from './PensionsOverviewSelector';
import {
  pensionSelector,
  pensionIDSelector,
  isEditSelector,
  ownersOptionsSelector,
  typesOptionsSelector,
  agesOptionsSelector,
  pensionOwnerSelector,
} from './PensionAddEditSelector';
import {
  updateData,
  updateSupportData,
  save,
  fetchData,
  updateValidation,
} from '../../AdvWorkflow/AdvWorkflowActions';
import {
  BACKEND_KEY,
  PENSIONS_CRUD_OVERVIEW,
  JOINT_SURVIVOR,
  LUMP_SUM,
} from '../PensionWorkflowConstants';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';
import { onCancel as onCancelAddEditPensions } from './PensionAddEditActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  graphPensions: graphPensionsSelector(state, ownProps),
  pension: pensionSelector(state, ownProps),
  pensionID: pensionIDSelector(state, ownProps),
  isEdit: isEditSelector(state, ownProps),
  ownersOptions: ownersOptionsSelector(state, ownProps),
  typesOptions: typesOptionsSelector(state, ownProps),
  agesOptions: agesOptionsSelector(state, ownProps),

  defaultJointSurvivorBenefit:
    dataSelector(state, ownProps)('NewPensionJointSurvivorDefaultSurvivorBenefit') || 0,
  defaultDistributionAge: dataSelector(state, ownProps)('NewPensionDefaultDistributionAge') || 0,
  defaultDistributionAtRetirement:
    dataSelector(state, ownProps)('NewPensionDefaultDistributionAtRetirement') || false,
  pensionOwners: pensionOwnerSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  onSave: (
    graphPensions,
    workflowId,
    state,
    defaultJointSurvivorBenefit,
    pensionID,
    clientId,
  ) => () => {
    dispatch(
      updateData(
        {
          [BACKEND_KEY]: graphPensions.map(pension => {
            if ((pension.Id || pension.frontEndId) === pensionID) {
              const typeChanged = state.type !== pension.PensionPlanType;
              const newPension = clone(pension);
              if (typeChanged) {
                if (state.type === JOINT_SURVIVOR && pension.frontEndId) {
                  newPension.SurvivorBenefit = defaultJointSurvivorBenefit;
                }
                newPension.PensionPlanType = state.type;
              }
              newPension.Recipient = state.owner;
              newPension.OwnerModel = state.ownerModel;
              if (state.type === LUMP_SUM) {
                delete newPension.MonthlyPayment;
                newPension.LumpSumAmount = state.amount || 0;
              } else {
                delete newPension.LumpSumAmount;
                newPension.MonthlyPayment = state.amount || 0;
              }

              if (state.age === -1) {
                newPension.DistributionAtRetirement = true;
              } else {
                newPension.DistributionAtRetirement = false;
                newPension.DistributionAge = state.age;
              }
              return newPension;
            }
            return pension;
          }),
        },
        workflowId,
        clientId,
      ),
    );
    dispatch(
      updateValidation(buildMutation(`${BACKEND_KEY}.PensionsAddEdit`, []), workflowId, clientId),
    );
    dispatch(
      save(
        BACKEND_KEY,
        () => {
          dispatch(fetchData(workflowId, clientId, [BACKEND_KEY]));
          dispatch(
            updateSupportData(
              {
                [BACKEND_KEY]: {
                  PensionStepViewID: PENSIONS_CRUD_OVERVIEW,
                },
              },
              workflowId,
              clientId,
            ),
          );
        },
        errors => {
          dispatch(
            updateValidation(
              buildMutation(`${BACKEND_KEY}.PensionsAddEdit`, errors),
              workflowId,
              clientId,
            ),
          );
        },
        workflowId,
        clientId,
        false,
        d => d,
        () => {},
      ),
    );
  },
  onCancel: (workflowId, clientId, isEdit, graphPensions) => event => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(onCancelAddEditPensions(workflowId, clientId, isEdit, graphPensions));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
